export const useVisitors24h = () => ({ data: 0, isLoading: false });
